// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select {\n  border: 1px solid #c2c2c2;\n  border-radius: 0.25rem;\n  width: 100%;\n  padding: 2.96px;\n  padding: 0.185rem;\n  font-size: 12px;\n  font-size: 0.75rem; }\n  .select:not(:disabled):hover, .select:not(:disabled):focus {\n    outline: none;\n    border-color: #000; }\n  .select:not(:disabled):active {\n    border-color: #bfd5e2; }\n  .select:disabled {\n    background-color: #e6e9ea;\n    color: #666666; }\n  .select--content {\n    width: auto; }\n  .select--header {\n    margin: -4px 4px 0;\n    margin: -0.25rem 0.25rem 0;\n    width: auto;\n    max-width: 21ch; }\n  .select-group {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  padding: 8px 0 8px 16px;\n  color: #33475f;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; }\n", ""]);
// Exports
exports.locals = {
	"select": "select",
	"select--content": "select--content",
	"select--header": "select--header",
	"select-group": "select-group"
};
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./~/css-loader/dist/cjs.js?{"modules":{"localIdentName":"[local]"}}!./~/postcss-loader/lib!./~/sass-loader!./components/select-label/select-label.scss
// module id = MG2x
// module chunks = 1